// extracted by mini-css-extract-plugin
export default {"reactionEmoji":"style_reactionEmoji__Fw7cl","reactionUser":"style_reactionUser__kiSn7"};